import axios from "axios";
import Swal from "sweetalert2";
import { isObject } from "formik";
import { baseURL, getToken } from "./api_base";

axios.defaults.headers.common["Access-Control-Allow-Origin"] =
  "GET, POST, DELETE, PUT"; // definindo o que meu axios pode fazer

export const getLogsSankhya = () =>
  axios
    .get(`${baseURL}/logs_sankhya`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      timeout: 120000, // 2 min: evita carregar para sempre se o backend não responder
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });

// Conteúdo completo de um log (inclui envio e retorno, que a listagem não traz)
export const getLogSankhyaById = (id) =>
  axios
    .get(`${baseURL}/logs_sankhya/${id}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      timeout: 120000,
    })
    .then((response) => response)
    .catch((error) => {
      console.log(error);
    });
